module.exports = __webpack_public_path__ + "static/media/batch-cupones.53e67c9c.jpg";